import type { AnswersApiQuery } from "@/Modules/Models/Api/Questionnaire";
import type { QuestionnaireStore } from "../Store";
import QuestionnaireAnswersTransformer, {
  type QuestionnaireAnswersTransformerType,
} from "@/Modules/Transformers/Questionaire/QuestionnaireAnswers";

import QuestionnairesApiConnector from "@/Services/TherapyApi/Questionnaires";

import { danger } from "@/Utils/Debug";

class FetchAnswerQuestionnaireActionHandler {
  constructor(
    private readonly questionnaireStore: QuestionnaireStore,
    private readonly questionnairesApiConnector = new QuestionnairesApiConnector(),
    private readonly questionnaireAnswersTransformer: QuestionnaireAnswersTransformerType = QuestionnaireAnswersTransformer
  ) {}

  public async handle(userQuestionnaireUuid: string): Promise<void> {
    this.questionnaireStore.isLoading = true;

    const getAnswersApiQuery: AnswersApiQuery = {
      user_questionnaire_uuid: userQuestionnaireUuid,
    };

    this.questionnairesApiConnector
      .getQuestionnaireAnswers(getAnswersApiQuery)
      .then((questionnaireAnswersApiResponse) => {
        const QuestionnaireAnswers = this.questionnaireAnswersTransformer.toDomain(
          questionnaireAnswersApiResponse
        );
        this.questionnaireStore.customerAnswers[userQuestionnaireUuid] = QuestionnaireAnswers;
      })
      .catch(danger)
      .finally(() => {
        this.questionnaireStore.isLoading = false;
      });
  }
}

export default FetchAnswerQuestionnaireActionHandler;
